import React, { useState, useEffect } from 'react';
import auctionService from '../services/auctionService';
import { formatDate } from '../utils/validators';
import './Messages.css';

const Messages = () => {
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const fetchConversations = async () => {
      // Mock data - in real app, fetch from API
      const mockConversations = [
        {
          id: 1,
          name: 'John Doe',
          auctionTitle: '2020 Honda Civic',
          lastMessage: 'Is this vehicle available?',
          timestamp: new Date(Date.now() - 3600000),
          unread: 2,
        },
        {
          id: 2,
          name: 'Jane Smith',
          auctionTitle: '2019 Toyota Camry',
          lastMessage: 'What is the final price?',
          timestamp: new Date(Date.now() - 7200000),
          unread: 0,
        },
      ];
      setConversations(mockConversations);
      setLoading(false);
    };

    fetchConversations();
  }, []);

  const handleSelectConversation = async (conversation) => {
    setSelectedConversation(conversation);
    // In real app, fetch messages from API
    const mockMessages = [
      {
        id: 1,
        sender: 'buyer',
        text: 'Is this vehicle available?',
        timestamp: new Date(Date.now() - 3600000),
      },
      {
        id: 2,
        sender: 'seller',
        text: 'Yes, it is available. Auction ends in 2 days.',
        timestamp: new Date(Date.now() - 3500000),
      },
      {
        id: 3,
        sender: 'buyer',
        text: 'What is the current bid?',
        timestamp: new Date(Date.now() - 3400000),
      },
    ];
    setMessages(mockMessages);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    setSending(true);
    const result = await auctionService.sendMessage(selectedConversation.id, newMessage);
    setSending(false);

    if (result.success) {
      setMessages([
        ...messages,
        {
          id: messages.length + 1,
          sender: 'seller',
          text: newMessage,
          timestamp: new Date(),
        },
      ]);
      setNewMessage('');
    }
  };

  return (
    <div className="container py-4">
      <h1>Messages</h1>

      <div className="messages-container">
        {/* Conversation List */}
        <div className="conversation-list">
          {loading ? (
            <div className="spinner"><div className="loading"></div></div>
          ) : conversations.length === 0 ? (
            <div className="empty-state">
              <p>No messages yet</p>
            </div>
          ) : (
            conversations.map((conv) => (
              <div
                key={conv.id}
                className={`conversation-item ${selectedConversation?.id === conv.id ? 'active' : ''}`}
                onClick={() => handleSelectConversation(conv)}
              >
                <div className="conv-avatar">{conv.name[0]}</div>
                <div className="conv-content">
                  <div className="conv-header">
                    <strong>{conv.name}</strong>
                    {conv.unread > 0 && <span className="badge">{conv.unread}</span>}
                  </div>
                  <p className="conv-auction">{conv.auctionTitle}</p>
                  <p className="conv-message">{conv.lastMessage}</p>
                </div>
                <div className="conv-time">{formatDate(conv.timestamp, 'time')}</div>
              </div>
            ))
          )}
        </div>

        {/* Chat View */}
        <div className="chat-view">
          {selectedConversation ? (
            <>
              <div className="chat-header">
                <h2>{selectedConversation.name}</h2>
                <p className="text-muted">{selectedConversation.auctionTitle}</p>
              </div>

              <div className="messages-area">
                {messages.map((msg) => (
                  <div key={msg.id} className={`message ${msg.sender}`}>
                    <div className="message-content">{msg.text}</div>
                    <div className="message-time">{formatDate(msg.timestamp, 'time')}</div>
                  </div>
                ))}
              </div>

              <form onSubmit={handleSendMessage} className="message-input-form">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type your message..."
                    disabled={sending}
                  />
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={sending || !newMessage.trim()}
                  >
                    {sending ? 'Sending...' : 'Send'}
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div className="no-conversation">
              <p>Select a conversation to start messaging</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Messages;
